import type { Job, WorkOrder } from '@jms/model';

/** Zone every job, stage and task date is shown in: alternate site, then job site, then the general setting zone, then UTC; shared so every board, detail and editor reads one day. */
export function stageItemTimezone(stage: { alternateSite?: { address?: { timezone?: string } } } | null | undefined, jobSite: { address?: { timezone?: string } } | null | undefined, regionTimezone: string | null | undefined): string {

  return stage?.alternateSite?.address?.timezone ?? jobSite?.address?.timezone ?? regionTimezone ?? 'UTC';
}

/** A job editor's zone for a row's stage: that stage of the job, else the stage the editor is open on; the Items and Tasks boards of every job shell date their rows through it. */
export function jobStageTimezone(job: Pick<Job, 'workOrders' | 'site'> | null | undefined, stageId: string | undefined, openStage: WorkOrder | undefined, regionTimezone: string | null | undefined): string {

  return stageItemTimezone(job?.workOrders?.find(stage => stage._id === stageId) ?? openStage, job?.site, regionTimezone);
}
